import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const getActionIcon = (action) => {
  switch (action) {
    case 'create':
    case 'created':
    case 'lead_created':
      return <AddCircleOutlineIcon fontSize="small" sx={{ color: '#4caf50' }} />;
    case 'upload':
    case 'document_upload':
    case 'document_uploaded':
      return <CloudUploadOutlinedIcon fontSize="small" sx={{ color: '#2196f3' }} />;
    case 'assign':
    case 'assignment':
    case 'reassign':
      return <PersonAddOutlinedIcon fontSize="small" sx={{ color: '#9c27b0' }} />;
    case 'status_change':
    case 'status_changed':
    case 'status_update':
      return <SwapHorizIcon fontSize="small" sx={{ color: '#ff9800' }} />;
    case 'edit':
    case 'update':
    case 'student_updated':
    case 'application_submitted':
      return <EditOutlinedIcon fontSize="small" sx={{ color: '#607d8b' }} />;
    case 'chat':
    case 'message':
      return <ChatOutlinedIcon fontSize="small" sx={{ color: '#00bcd4' }} />;
    case 'delete':
    case 'document_deleted':
      return <DeleteOutlinedIcon fontSize="small" sx={{ color: '#f44336' }} />;
    case 'view':
      return <VisibilityOutlinedIcon fontSize="small" sx={{ color: '#78909c' }} />;
    default:
      return <InfoOutlinedIcon fontSize="small" sx={{ color: '#9e9e9e' }} />;
  }
};

const formatTimestamp = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHrs = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHrs / 24);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHrs < 24) return `${diffHrs}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const ActivityItem = ({ activity }) => {
  const { action, description, userName, createdAt } = activity;

  return (
    <Box sx={{ display: 'flex', gap: 2, py: 1.5 }}>
      {/* Icon */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 32,
          height: 32,
          borderRadius: '50%',
          backgroundColor: 'grey.100',
          flexShrink: 0,
          mt: 0.25,
        }}
      >
        {getActionIcon(action)}
      </Box>

      {/* Content */}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
          {description}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5, flexWrap: 'wrap' }}>
          {userName && (
            <Chip
              label={userName}
              size="small"
              variant="outlined"
              sx={{ height: 22, fontSize: '0.7rem' }}
            />
          )}
          <Typography variant="caption" color="text.secondary">
            {formatTimestamp(createdAt)}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ActivityItem;
